import { Goal } from '../types/contentManagement';

export const getGoalsByLinkedContent = (
  allGoals: Goal[],
  whichContent: 'pillar' | 'category',
  linkedContent: string,
) => {
  let constraint: (goal: Goal) => boolean | undefined;
  switch (whichContent) {
    case 'pillar':
      constraint = (goal: Goal) => goal?.linkedPillars?.includes(linkedContent);
      break;
    case 'category':
      constraint = (goal: Goal) => goal?.linkedCategories?.includes(linkedContent);
      break;
  }
  const result = allGoals.filter((goal) => constraint(goal));
  return result;
};

export const getPossiblePillars = (allGoals: Goal[], linkedCategory: string) => {
  const linkGoals = getGoalsByLinkedContent(allGoals, 'category', linkedCategory);
  const possiblePillars = new Set<string>();
  linkGoals.forEach((goal) => {
    if (Array.isArray(goal.linkedPillars)) {
      goal?.linkedPillars.forEach((pillar) => possiblePillars.add(pillar));
    }
  });
  return Array.from(possiblePillars);
};

export const getPossibleCategories = (allGoals: Goal[], linkedPillar: string) => {
  const linkGoals = getGoalsByLinkedContent(allGoals, 'pillar', linkedPillar);
  const possibleCategories = new Set<string>();
  linkGoals.forEach((goal) => {
    if (Array.isArray(goal.linkedCategories)) {
      goal?.linkedCategories.forEach((category) => possibleCategories.add(category));
    }
  });
  return Array.from(possibleCategories);
};

export const getContentManagementUploadFileName = (type: 'pillar' | 'goal') => {
  let prefix: string;
  switch (type) {
    case 'pillar':
      prefix = 'pill';
      break;
    case 'goal':
      prefix = 'goal';
      break;
    default:
      prefix = 'cmgm';
  }
  const randomString = Math.random().toString(36).substring(2, 10);
  return prefix?.concat('-', randomString);
};
